import * as yup from "yup";

const orderRejectionSchema = yup.object().shape({
  rejectionReason: yup
    .string()
    .required("Rejection reason is required"),

  rejectionImages: yup
    .array()
    .min(2, "You must upload at least 2 images")
    .required("Rejection images are required")
    .test("is-image", "All files must be image types", (files) => {
      return (
        Array.isArray(files) &&
        files.length > 0 &&
        files.every((file) =>
          file?.originFileObj?.type?.startsWith("image/")
        )
      );
    }),

  rejectionRemarks: yup
    .string()
    .max(250, "Remarks cannot exceed 250 characters")
    .notRequired(),
});

export default orderRejectionSchema;